import http, {HttpRequest} from "./http";
import {config} from "../config";
import AppMessage from "./AppMessage";
import {md5} from "./md5";

export class Api {

    token() {
        return localStorage.getItem("_jwt");
    }

    bearearInit() {
        let token = this.token();
        if (!token) token = "";
        http.bearer = token;
    }

    login(token: string) {
        localStorage.setItem("_jwt", token );
        http.bearer = token;
        /// window.location.href = process.env.PUBLIC_URL??"/"
    }

    logout() {
        localStorage.setItem("_jwt", "" );
        let prevToken = localStorage.getItem('prevToken')
        if (prevToken) {
            localStorage.setItem('prevToken', "")
            localStorage.setItem("_jwt", prevToken)
            this.bearearInit()
        } else {
            http.bearer = "";
        }
    }

    setLang(lang: string) {
        localStorage.setItem('lang', lang);
        this.initLang();
    }

    getLang() {
        let lang = localStorage.getItem('lang');
        if (!lang) lang = 'en';
        return 'ua';
    }

    constructor() {
        this.bearearInit();
        http.baseUrl = config.api;
        this.initLang();
    }

    private initLang() {
        http.setHeader("x-lang", this.getLang());
    }

    public delete<T = any>(url: string, smart: boolean = false) {
        if (!smart) return http.delete<AppMessage<T>>(url);
        if (this.smarts[url]) return this.smarts[url];
        const new_smart = http.delete<AppMessage<T>>(url);
        this.smarts[url] = new_smart;
        new_smart.ok(() => {
            this.smarts[url] = null;
        }).error(() => {
            this.smarts[url] = null;
        });
        return new_smart;
    }

    public makeurl(url: string) {
        let realUrl = http.baseUrl.replace("{{random}}", '0') + url;
        if (realUrl.indexOf("?") === -1) {
            realUrl += "?jwt=" + http.bearer;
        } else {
            realUrl += "&jwt=" + http.bearer;
        }
        return realUrl;
    }


    private smarts: any = {};
    public get<T = any>(url: string, smart: boolean = false): HttpRequest<AppMessage<T>> {
        if (!smart) return http.get<AppMessage<T>>(url);
        if (this.smarts[url]) return this.smarts[url];
        const new_smart = http.get<AppMessage<T>>(url);
        this.smarts[url] = new_smart;
        new_smart.ok(() => {
            this.smarts[url] = null;
        }).error(() => {
            this.smarts[url] = null;
        });
        return new_smart;
    }


    public post<T = any>(url: string, data: any, smart: boolean = false): HttpRequest<AppMessage<T>>  {
        if (!smart) return http.post<AppMessage<T>>(url, data);
        const hash = md5(url + JSON.stringify(data));
        if (this.smarts[hash]) return this.smarts[hash];
        const new_smart = http.post<AppMessage<T>>(url, data);
        this.smarts[hash] = new_smart;
        new_smart.ok(() => {
            this.smarts[hash] = null;
        }).error(() => {
            this.smarts[hash] = null;
        });
        return new_smart;
    }
}

let api: Api = new Api();
export default api;
